export default __webpack_public_path__ + "static/media/60.bc4f9527.svg";